import Button from 'components/Button';
import Chip from 'components/Chip';
import DownloadIcon from 'components/icons/Download';
import SettingsIcon from 'components/icons/Settings';
import { HeadButtons, PageHeadContainer, PageTitle } from 'components/PageHead';
import { FC, useContext } from 'react';
import { Link } from 'react-router-dom';
import { MenteesContext } from '..';

const Head: FC = () => {
  const { count, filteredCount } = useContext(MenteesContext);

  return (
    <PageHeadContainer>
      <PageTitle>
        <h1>Mentorés</h1>
        <Chip color="var(--primary-700)" bgColor="var(--primary-50)">
          {count && typeof filteredCount === 'number'
            ? count === filteredCount
              ? count
              : `${filteredCount}/${count}`
            : ''}
        </Chip>
      </PageTitle>
      <HeadButtons>
        <Link to="export">
          <Button variant="outlined" icon={<DownloadIcon />}>
            Exporter la liste
          </Button>
        </Link>

        <Button 
          variant="outlined" 
          icon={<SettingsIcon />} 
          onClick={() => window.dispatchEvent(new CustomEvent('open-mentee-settings'))}
        >
          Colonnes
        </Button>
      </HeadButtons>
    </PageHeadContainer>
  );
};

export default Head;
